import React, { useState } from 'react';
import { connect } from 'react-redux';
/* import { withFirebase } from 'react-redux-firebase';
 */import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import { isMobile } from 'react-device-detect';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import Snackbar from '../../../components/Snackbar';
import { validationUpdatePassword } from '../../../utils/validations';
import {auths} from '../../../configs/environments/firebase/firebaseApp'

const fields = [
  {
    name: 'currentPassword',
    label: 'Contraseña actual'
  },
  {
    name: 'newPassword',
    label: 'Nueva contraseña'
  },
  {
    name: 'confirmPassword',
    label: 'Confirmar nueva contraseña'
  }
];

const useStyles = makeStyles({
  IconButtonRoot: {
    color: '#c1c1c1',
    padding: 5
  }
});

const FormUpdatePassword = props => {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false
  });

  const handleToggleShowPassword = name => event => {
    event.preventDefault();
    setShowPassword({
      ...showPassword,
      [name]: !showPassword[name]
    });
  };

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors
  } = props;
  return (
    <form onSubmit={handleSubmit}>
      {fields.map(({ name, label }) => {
        return (
          <div key={name}>
            <TextField
              id={name}
              name={name}
              label={label}
              value={values[name]}
              onChange={handleChange}
              onBlur={handleBlur}
              type={showPassword[name] ? 'text' : 'password'}
              helperText={touched[name] && errors[name] ? errors[name] : ''}
              error={touched[name] && errors[name] ? true : false}
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      classes={{
                        root: classes.IconButtonRoot
                      }}
                      aria-label="Toggle password visibility"
                      onClick={handleToggleShowPassword(name)}
                    >
                      {showPassword[name] ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </div>
        );
      })}
      <br />
      <ButtonBase type="submit" variant="primary">
        Guardar Cambios
      </ButtonBase>
    </form>
  );
};

const UpdatePassword = props => {
  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'info'
  });

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'info'
    });
  };

  const submitOldNewConfirmPassword = (
    values,
    { setSubmitting, setFieldError, resetForm }
  ) => {
    setSubmitting(false);
    const { currentPassword, newPassword, confirmPassword } = values;
    if (confirmPassword === newPassword) {
      const {
        profile: { email }
      } = props;
      auths
        .signInWithEmailAndPassword(email, currentPassword)
        .then(function(user) {
          auths
            .currentUser.updatePassword(newPassword)
            .then(function(res) {
              setFeedbackMessage({
                open: true,
                message: 'Contraseña actualizada exitosamente!',
                variant: 'success'
              });
              resetForm();
            })
            .catch(function(err) {});
        })
        .catch(function(error) {
          if (error.code === 'auth/wrong-password') {
            setFieldError(
              'currentPassword',
              'La contraseña no es válida o el usuario no tiene una contraseña'
            );
          }
        });
    } else {
      setFieldError(
        'confirmPassword',
        'La nueva contraseña y su confirmación no coinciden'
      );
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          currentPassword: '',
          newPassword: '',
          confirmPassword: ''
        }}
        validationSchema={validationUpdatePassword}
        onSubmit={submitOldNewConfirmPassword}
        render={props => (
          <FormUpdatePassword
            handleSubmit={submitOldNewConfirmPassword}
            {...props}
          />
        )}
      />

      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '8px' : '80px'}
      />
    </>
  );
};

const mapStateToProps = state => ({
  profile: state.authClient
});

export default connect(mapStateToProps)(UpdatePassword);
